import { DateTime } from 'luxon';

export function toLuxon(value: any) {
  if (value instanceof DateTime) {
    return value;
  }
  if (value?.date) {
    value = value.date;
  }
  if (value) {
    return DateTime.fromFormat(value.slice(0, -7), 'y-LL-dd hh:mm:ss');
  }
  return null;
}
